<!-- @format -->
<div class="modal-content">
   <div class="modal-header">
      <button type="button" class="close" aria-hidden="true" (click)="closeModal()">×</button>
      <h3>Inserting Link</h3>
   </div>
   <div class="modal-body">
      <div class="container-fluid">
         <div class="row">
            <label for="basic-url">URL</label>
            <div class="url__group">
               <!--               <span class="input-group-addon" id="basic-addon3">https://</span>-->
               <p-dropdown
                  #ddProtocol
                  [options]="protocolOptions"
                  [(ngModel)]="selectedProtocol"
                  optionLabel="value"
                  [disabled]="isConfirm"
                  styleClass="url__dropdown"
               >
                  <ng-template let-selected pTemplate="selectedItem">
                     <span>
                        {{ selected.label }}
                     </span>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                     <span>
                        {{ item.label }}
                     </span>
                  </ng-template>
               </p-dropdown>
               <input
                  #inputUrl
                  type="text"
                  class="form-control url__input"
                  id="basic-url"
                  [disabled]="isConfirm"
                  aria-describedby="basic-addon3"
                  [(ngModel)]="url"
                  (ngModelChange)="sanitizeUrl()"
               />
            </div>
         </div>

         <div class="row">
            <div class="form-group">
               <label for="link-label">Text</label>
               <input type="text" class="form-control" id="link-label" [(ngModel)]="text" />
            </div>
         </div>

         <div class="row">
            <button class="btn btn-primary" [ngClass]="{ active: isConfirm }" aria-hidden="true" (click)="useConfirm()">
               Use Confirm Link
            </button>
         </div>
      </div>
   </div>
   <div class="modal-footer">
      <button class="btn btn-primary" aria-hidden="true" (click)="successModal()">Accept</button>
      <button class="btn btn-default" aria-hidden="true" (click)="closeModal()">Close</button>
   </div>
</div>
